import { render } from "./PixelClouds.vue?vue&type=template&id=45ab0155&scoped=true"
import script from "./PixelClouds.vue?vue&type=script&lang=js"
export * from "./PixelClouds.vue?vue&type=script&lang=js"

import "./PixelClouds.vue?vue&type=style&index=0&id=45ab0155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ab0155"]])

export default __exports__